@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.unsupportedRequestContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}
